<template>
  <div class="user-info-container">
    <el-card class="password-card">
      <div slot="header" class="clearfix">
        <span>用户信息</span>
      </div>
      <el-form :model="userForm" :rules="userRules" ref="userForm" label-width="120px" label-position="left">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input type="password" v-model="userForm.oldPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input type="password" v-model="userForm.newPassword" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input type="password" v-model="userForm.confirmPassword" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="updatePassword">更新密码</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'UserInfo',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.userForm.confirmPassword !== '') {
          this.$refs.userForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.userForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userForm: {
        username: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      userRules: {
        oldPassword: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    async updatePassword() {
      try {
        await this.$refs.userForm.validate();
        await api.updatePassword(
          this.userForm.username,
          this.userForm.oldPassword,
          this.userForm.newPassword
        );
        this.$message.success('密码更新成功');
        this.userForm.oldPassword = '';
        this.userForm.newPassword = '';
        this.userForm.confirmPassword = '';
      } catch (error) {
        console.error('Password update error:', error);
        this.$message.error('密码更新失败');
      }
    },
    async fetchUserInfo() {
      try {
        const response = await api.getUserInfo();
        this.userForm.username = response.data.username;
      } catch (error) {
        console.error('获取用户信息失败:', error);
        this.$message.error('获取用户信息失败');
      }
    }
  },
  mounted() {
    this.fetchUserInfo();
  }
};
</script>

<style scoped>
.user-info-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.password-card {
  width: 400px;
  max-width: 90%;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button {
  width: 100%;
}

.el-form-item__label {
  text-align: left !important;
}

.el-form--label-left .el-form-item__label {
  text-align: left;
}
</style>
